import { BundleItemType, BundleStatus } from 'generated/graphql';

import { AllPrograms, SubscriptionBundle } from '../../common/bundle.types';
import { BundlesModelDispatcher, ModalCta } from './editBundlePrice.vm';

export const getCta = (
  dispatch: BundlesModelDispatcher,
  isDraftMode: boolean,
  saving: boolean,
  publishing: boolean,
): Array<ModalCta> => {
  if (isDraftMode) {
    return [
      {
        label: 'Save',
        onClick: () => dispatch('savePriceChange'),
        color: 'primaryTonal',
        submitting: saving,
        disabled: saving || publishing,
      },
      {
        label: 'Publish',
        onClick: () => dispatch('publishBundle'),
        submitting: publishing,
        disabled: saving || publishing,
      },
    ];
  }
  return [
    {
      label: 'Save',
      onClick: () => dispatch('savePriceChange'),
      submitting: saving,
      disabled: saving,
    },
  ];
};

export const toNotPublishedProgramNames = (params: {
  bundleProgramIds: Array<number>;
  subscriptionPrograms: AllPrograms;
  allSubscriptionBundles: Array<SubscriptionBundle>;
}): Array<string> => {
  const publishedProgramIds = new Set(
    params.allSubscriptionBundles
      .filter((b) => b.status === BundleStatus.Published)
      .flatMap((b) => b.items)
      .filter((item) => item.itemType === BundleItemType.Program)
      .map((item) => item.itemId)
      .filter((id): id is number => id !== undefined),
  );

  return params.subscriptionPrograms
    .filter((p) => params.bundleProgramIds.includes(p.id))
    .filter((p) => !publishedProgramIds.has(p.id))
    .map((p) => p.name);
};
